import cacheLs from "../cacheLs";

export default {
  saveSelectedMicroApp(state, data) {
    state.getCurrentMicroApp = data
    cacheLs.set_selected_microapp(data)
  }
}
